import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import ProductCreateForm from '~/containers/productCreate/productCreate';

export class ProductCreatePage extends Component {
  render() {
    const cancelButton = (
      <Link to={`/products`}>
        <Button color="secondary">Cancel</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar back="/products" backText="Products" title="Add product" button={cancelButton} />
        <ProductCreateForm />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(ProductCreatePage));



// WEBPACK FOOTER //
// ./src/pages/productCreate/productCreate.jsx